import type { EditorThemeClasses } from 'lexical'

export const nodesClasses: EditorThemeClasses = {
  heading: {
    h1: 'MarkdownEditor__h1',
    h2: 'MarkdownEditor__h2',
    h3: 'MarkdownEditor__h3',
  },
  image: 'MarkdownEditor__image',
  link: 'MarkdownEditor__link',
  list: {
    checklist: 'MarkdownEditor__checklist',
    listitem: 'MarkdownEditor__listItem',
    listitemChecked: 'MarkdownEditor__listItemChecked',
    listitemUnchecked: 'MarkdownEditor__listItemUnchecked',
    nested: {
      listitem: 'MarkdownEditor__nestedListItem',
    },
    olDepth: ['MarkdownEditor__ol1', 'MarkdownEditor__ol2', 'MarkdownEditor__ol3', 'MarkdownEditor__ol4', 'MarkdownEditor__ol5'],
    ul: 'MarkdownEditor__ul',
  },
  paragraph: 'MarkdownEditor__paragraph',
  quote: 'MarkdownEditor__quote',
  table: 'MarkdownEditor__table',
  tableCell: 'MarkdownEditor__tableCell',
  tableRow: 'MarkdownEditor__tableRow',
  text: {
    bold: 'MarkdownEditor__textBold',
    italic: 'MarkdownEditor__textItalic',
    strikethrough: 'MarkdownEditor__textStrikethrough',
  },
}
